import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { getEffectDispose, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { record_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { DateTimeExtensions_toDate, DateTimeOffsetExtensions_toDateHHmmss, DateOnlyExtensions_toDate, String_capitalize, Locale_get_FromSelectedLanguage } from "../../Utils.js";
import * as react from "react";
import { iterate } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { startImmediate, createCancellationToken, cancel } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { map as map_1, defaultArg, toArray } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { loadMortgageInvoice as loadMortgageInvoice_1, loadCurrentMortgageValue as loadCurrentMortgageValue_1, loadHistoricalMortgageValue } from "./Api.js";
import { dotsLoading } from "../../ViewUtils.js";
import { error } from "../../Components/Message/Message.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { renderTable as renderTable_1 } from "../../Components/Table/Table.js";
import { map, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { uncurry, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { UTC__toDateTimeOffset } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { TabContainerProps, renderTabContainer, Tab } from "../../Components/TabContainer/TabContainer.js";
import "../../../src/Containers/MortgageValue/View.scss";


export class HistoricalMortgageValueProps extends Record {
    constructor(GlobalDependencies, ContractNr) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
    }
}

export function HistoricalMortgageValueProps$reflection() {
    return record_type("Containers.MortgageValue.View.HistoricalMortgageValueProps", [], HistoricalMortgageValueProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type]]);
}

export const renderHistoricalMortgageValue = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const historicalMortgageValueLoadState = react.useState(new LoadState$2(0));
    const pendingRequestRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => {
        iterate((cts) => {
            cancel(cts);
        }, toArray(pendingRequestRef.current));
        const newCTS = createCancellationToken();
        pendingRequestRef.current = newCTS;
        historicalMortgageValueLoadState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadHistoricalMortgageValue(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            historicalMortgageValueLoadState[1](arg);
            return singleton.Zero();
        })), newCTS);
        return getEffectDispose(() => {
            iterate((cts_1) => {
                cancel(cts_1);
            }, toArray(pendingRequestRef.current));
        });
    })();
        return () => disp.Dispose();
    }, [props.GlobalDependencies, props.ContractNr]);
    let paginatedTableHtml;
    const matchValue = historicalMortgageValueLoadState[0];
    switch (matchValue.tag) {
        case 1: {
            paginatedTableHtml = dotsLoading;
            break;
        }
        case 3: {
            paginatedTableHtml = error(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            paginatedTableHtml = Pagination()(new PageinationProps$1((hmvs) => renderTable_1(ofArray([String_capitalize(getTranslation("Common.Month")), getTranslation("CustomerContract.Invoicee.Agreements.MortgageValue.Value"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageValue.ValueRange"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageValue.ChangedDate")]), map((hmv) => ofArray([DateOnlyExtensions_toDate(locale.ILocale, hmv.Month), toText(printf("%.2f"))(hmv.ContractValue), int32ToString(hmv.ValueRange), DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTimeOffset(hmv.ChangedDateSwedish))]), hmvs)), matchValue.fields[0], 10, 0));
            break;
        }
        default: {
            paginatedTableHtml = react.createElement(react.Fragment, {});
        }
    }
    return react.createElement("div", {
        className: "p-2",
    }, paginatedTableHtml);
}, "HistoricalMortgageValue", uncurry(2, void 0), void 0, "renderHistoricalMortgageValue", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageValue\\View.fs", 87);

export class CurrentMortgageValueProps extends Record {
    constructor(GlobalDependencies, ContractNr) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
    }
}

export function CurrentMortgageValueProps$reflection() {
    return record_type("Containers.MortgageValue.View.CurrentMortgageValueProps", [], CurrentMortgageValueProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type]]);
}

export const renderCurrentMortgageValue = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const currentMortgageValueLoadState = react.useState(new LoadState$2(0));
    const pendingRequestRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => {
        iterate((cts) => {
            cancel(cts);
        }, toArray(pendingRequestRef.current));
        const newCTS = createCancellationToken();
        pendingRequestRef.current = newCTS;
        currentMortgageValueLoadState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadCurrentMortgageValue_1(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            currentMortgageValueLoadState[1](arg);
            return singleton.Zero();
        })), newCTS);
        return getEffectDispose(() => {
            iterate((cts_1) => {
                cancel(cts_1);
            }, toArray(pendingRequestRef.current));
        });
    })();
        return () => disp.Dispose();
    }, [props.GlobalDependencies, props.ContractNr]);
    let paginatedTableHtml;
    const matchValue = currentMortgageValueLoadState[0];
    switch (matchValue.tag) {
        case 1: {
            paginatedTableHtml = dotsLoading;
            break;
        }
        case 3: {
            paginatedTableHtml = error(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            paginatedTableHtml = Pagination()(new PageinationProps$1((cmvs) => renderTable_1(ofArray([String_capitalize(getTranslation("Common.Month")), getTranslation("CustomerContract.Invoicee.Agreements.MortgageValue.Value"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageValue.ValueRange"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageValue.ChangedDate")]), map((cmv) => {
                let clo;
                return ofArray([DateOnlyExtensions_toDate(locale.ILocale, cmv.Month), defaultArg(map_1((clo = toText(printf("%.2f")), clo), cmv.ValueNow), "-"), int32ToString(cmv.ValueRange), DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTimeOffset(cmv.ChangedDateSwedish))]);
            }, cmvs)), matchValue.fields[0], 10, 0));
            break;
        }
        default: {
            paginatedTableHtml = react.createElement(react.Fragment, {});
        }
    }
    return react.createElement("div", {
        className: "p-2",
    }, paginatedTableHtml);
}, "CurrentMortgageValue", uncurry(2, void 0), void 0, "renderCurrentMortgageValue", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageValue\\View.fs", 164);

export class MortgageInvoiceProps extends Record {
    constructor(GlobalDependencies, ContractNr) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
    }
}

export function MortgageInvoiceProps$reflection() {
    return record_type("Containers.MortgageValue.View.MortgageInvoiceProps", [], MortgageInvoiceProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type]]);
}

export const renderMortgageInvoice = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const mortgageInvoiceLoadState = react.useState(new LoadState$2(0));
    const pendingRequestRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => {
        iterate((cts) => {
            cancel(cts);
        }, toArray(pendingRequestRef.current));
        const newCTS = createCancellationToken();
        pendingRequestRef.current = newCTS;
        mortgageInvoiceLoadState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadMortgageInvoice_1(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            mortgageInvoiceLoadState[1](arg);
            return singleton.Zero();
        })), newCTS);
        return getEffectDispose(() => {
            iterate((cts_1) => {
                cancel(cts_1);
            }, toArray(pendingRequestRef.current));
        });
    })();
        return () => disp.Dispose();
    }, [props.GlobalDependencies, props.ContractNr]);
    let paginatedTableHtml;
    const matchValue = mortgageInvoiceLoadState[0];
    switch (matchValue.tag) {
        case 1: {
            paginatedTableHtml = dotsLoading;
            break;
        }
        case 3: {
            paginatedTableHtml = error(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            paginatedTableHtml = Pagination()(new PageinationProps$1((hmvs) => {
                const locale_1 = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
                return renderTable_1(ofArray([getTranslation("CustomerContract.Invoicee.Agreements.MortgageInvoice.MortgageInvoiceNr"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageInvoice.MortgageInvoiceAmount"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageInvoice.MortgageInvoicePaid"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageInvoice.MortgageInvoiceRemainingAmount"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageInvoice.MortgageInvoiceDueDate"), getTranslation("CustomerContract.Invoicee.Agreements.MortgageInvoice.BlockedStatus")]), map((hmv) => ofArray([toText(printf("%i"))(hmv.MortgageInvoiceId), toText(printf("%.2f"))(hmv.Amount), toText(printf("%.2f"))(hmv.PaidAmount), toText(printf("%.2f"))(hmv.RemainingAmount), DateTimeExtensions_toDate(locale_1.ILocale, hmv.DueDate), (hmv.BlockedStatus === 2) ? getTranslation("CustomerContract.Invoicee.Agreements.MortgageInvoice.BlockedStatus.Blocked") : ""]), hmvs));
            }, matchValue.fields[0], 10, 0));
            break;
        }
        default: {
            paginatedTableHtml = react.createElement(react.Fragment, {});
        }
    }
    return react.createElement("div", {
        className: "p-2",
    }, paginatedTableHtml);
}, "MortgageInvoice", uncurry(2, void 0), void 0, "renderMortgageInvoice", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageValue\\View.fs", 250);

export class MortgageValueContainerProps extends Record {
    constructor(ContractNr) {
        super();
        this.ContractNr = (ContractNr | 0);
    }
}

export function MortgageValueContainerProps$reflection() {
    return record_type("Containers.MortgageValue.View.MortgageValueContainerProps", [], MortgageValueContainerProps, () => [["ContractNr", int32_type]]);
}

export const renderMortgageValueContainer = FunctionComponent_Of_Z5A158BBF((props) => {
    let tabContentHtml_2;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const globalDependenciesLoadState = useSelector((state_1) => state_1.Model.GlobalDependencies);
    let contentHtml;
    switch (globalDependenciesLoadState.tag) {
        case 1: {
            contentHtml = dotsLoading;
            break;
        }
        case 3: {
            contentHtml = error(globalDependenciesLoadState.fields[0].split(""));
            break;
        }
        case 2: {
            const globalDeps = globalDependenciesLoadState.fields[0];
            let historicalMortgageValueTab;
            const tabContentHtml = renderHistoricalMortgageValue(new HistoricalMortgageValueProps(globalDeps, props.ContractNr));
            historicalMortgageValueTab = (new Tab(void 0, void 0, getTranslation("CustomerContract.Invoicee.Agreements.MortgageValue.HistoricalMortgageValue"), tabContentHtml));
            let currentMortgageValueTab;
            const tabContentHtml_1 = renderCurrentMortgageValue(new CurrentMortgageValueProps(globalDeps, props.ContractNr));
            currentMortgageValueTab = (new Tab(void 0, void 0, getTranslation("CustomerContract.Invoicee.Agreements.MortgageValue.CurrentMortgageValue"), tabContentHtml_1));
            contentHtml = renderTabContainer(new TabContainerProps([(tabContentHtml_2 = renderMortgageInvoice(new MortgageInvoiceProps(globalDeps, props.ContractNr)), new Tab(void 0, void 0, getTranslation("CustomerContract.Invoicee.Agreements.MortgageInvoice"), tabContentHtml_2)), currentMortgageValueTab, historicalMortgageValueTab]));
            break;
        }
        default: {
            contentHtml = react.createElement(react.Fragment, {});
        }
    }
    return react.createElement("div", {}, contentHtml);
}, "MortgageValueContainer", uncurry(2, void 0), void 0, "renderMortgageValueContainer", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageValue\\View.fs", 304);

